import { render, staticRenderFns } from "./Mascot.vue?vue&type=template&id=56196212&scoped=true&"
import script from "./Mascot.vue?vue&type=script&lang=ts&"
export * from "./Mascot.vue?vue&type=script&lang=ts&"
import style0 from "./Mascot.vue?vue&type=style&index=0&id=56196212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56196212",
  null
  
)

export default component.exports